import React from 'react'
import styled from 'styled-components'

function Admission_SchoolTerms() {
  return (
    <Wrapper>
    <p>Students should be habitually clean and always neatly dressed. The school uniform should be worn on all working days and for all school functions. Parents are advised not to send any expensive personal items to school with their children.</p>
  </Wrapper>
)
}
const Wrapper = styled.section`
p{
  font-size:2.3rem;
  line-height:1.1;
}
`

export default Admission_SchoolTerms